<template>
  <div class="folder-view">
    <router-view v-on:refreshUsage="refreshUsage"></router-view>
  </div>
</template>

<script>
export default {
  name: 'folderView',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    refreshUsage: function () {
      this.$emit('refreshUsage')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/components/Et/FolderView.vue